import { createSlice } from "@reduxjs/toolkit";

const expensesSlice = createSlice({
  name: "expenses",
  initialState: {
    expensesArray:[]
  },
  reducers: {
    getExpenses: (state, action) => {
  state.expensesArray =action.payload;
 },
 },
});

export const { getExpenses } = expensesSlice.actions;
export default expensesSlice.reducer;